import { loginApi } from '@/api/login'
import { addRecentLoginList } from '@/utils/cache'
import { FRONT_END_DOMAIN } from '@/config/config'
import cookies from 'js-cookie'
import * as jsBridge from '@vipsdk/js-bridge'

const tryno = cookies.get('tryno') || ''
const show_from = Number(cookies.get('show_from')) || 0

// 登录
export const login = query => {
  return new Promise(async (resolve, reject) => {
    try {
      try {
        query.show_from = show_from
        const deviceInfo = await jsBridge.client_get_device_info()
        query.device = {
          os: deviceInfo.os,
          account: deviceInfo.name
        }
      } catch (error) {
        console.log(error)
      }

      const res = await loginApi(query)
      const data = res.data
      const resCom = res.resp_common
      if (resCom.ret == 0) {
        // 保存到登录列表里
        addRecentLoginList(data.user_info, data.token)
      }
      resolve(res)
    } catch (error) {
      console.error(error)
      reject(error)
    }
  })
}

// 快速登录
export const quickLogin = query => {
  if (query && query.userInfo && query.token) {
    const data = {
      login_token: query.token,
      login_type: 4
    }
    return login(data)
  }
}

export const openDeviceAdmin = (token, openId) => {
  const url = `${location.protocol}//${FRONT_END_DOMAIN}/${tryno}/device/admin?token=${token}&openid=${openId}&sfrom=2`
  const params = {
    url,
    open_web: 'dev_mgr',
    popup: true, // 表示不继承父窗口
    width: 600,
    height: 420
  }
  jsBridge.client_openOptionWindow(params)
}
